











import { Component, Prop, Vue } from "vue-property-decorator";
import CzCard from "./CzCard.vue";
import CzGlow from "./CzGlow.vue";
import CzIcon from "./CzIcon.vue";
import CzTitle from "./CzTitle.vue";

// The outcome of an action (payment, message sent): mark, short title and the explanation.
@Component({ components: { CzCard, CzGlow, CzIcon, CzTitle } })
export default class CzStatus extends Vue {
  @Prop({ type: String, default: "ok" }) tone!: "ok" | "error";
  @Prop({ type: String, required: true }) title!: string;
  @Prop({ type: String, default: "" }) text!: string;
}
